module.exports = __webpack_public_path__ + "static/media/headlights-and-taillights-red.f513144c.svg";